import { createContext, useContext } from 'react'

export interface RegionState {
  region: string
  apiUrl: string
  probeData: unknown
  identifierType: string
}

const RegionContext = createContext<RegionState | null>(null)

export const RegionProvider = RegionContext.Provider

export function useRegion(): RegionState {
  const ctx = useContext(RegionContext)
  if (!ctx) {
    throw new Error('useRegion must be used within RegionProvider')
  }
  return ctx
}

export function useProbeData<T>(): T | null {
  const ctx = useContext(RegionContext)
  return (ctx?.probeData as T) ?? null
}
